import { SearchableSelect } from '@/shared/components'
import type { SearchableSelectProps } from '@/shared/components/ui/SearchableSelect'
import type { EligibilityFieldErrors } from './types'

type SelectOption = SearchableSelectProps['options'][number]

type EligibilityIdentityFieldsProps = {
  gender: string
  ethnicity: string
  educationLevel: string
  genderOptions: SelectOption[]
  ethnicityOptions: SelectOption[]
  educationOptions: SelectOption[]
  fieldErrors: EligibilityFieldErrors
  isGenderDisabled: boolean
  isEthnicityDisabled: boolean
  isEducationLevelDisabled: boolean
  onGenderChange: (value: string) => void
  onEthnicityChange: (value: string) => void
  onEducationLevelChange: (value: string) => void
}

export function EligibilityIdentityFields({
  gender,
  ethnicity,
  educationLevel,
  genderOptions,
  ethnicityOptions,
  educationOptions,
  fieldErrors,
  isGenderDisabled,
  isEthnicityDisabled,
  isEducationLevelDisabled,
  onGenderChange,
  onEthnicityChange,
  onEducationLevelChange
}: EligibilityIdentityFieldsProps) {
  return (
    <>
      <div
        className="animate-fade-in-up relative z-[12000]"
        style={{ animationDelay: '220ms' }}
      >
        <SearchableSelect
          label="Gender"
          value={gender}
          onChange={onGenderChange}
          placeholder="Select your gender"
          options={genderOptions}
          error={fieldErrors.gender}
          disabled={isGenderDisabled}
          required
        />
        <p className="mb-1 text-[11px] italic text-gray-400">
          Must match your driver's license
        </p>
      </div>

      <div
        className="animate-fade-in-up relative z-[11000]"
        style={{ animationDelay: '260ms' }}
      >
        <SearchableSelect
          label="Ethnicity"
          value={ethnicity}
          onChange={onEthnicityChange}
          placeholder="Select your ethnicity"
          options={ethnicityOptions}
          error={fieldErrors.ethnicity}
          disabled={isEthnicityDisabled}
          required
        />
      </div>

      <div
        className="animate-fade-in-up relative z-[10000]"
        style={{ animationDelay: '300ms' }}
      >
        <SearchableSelect
          label="Highest Education Level"
          value={educationLevel}
          onChange={onEducationLevelChange}
          placeholder="Select your highest education level"
          options={educationOptions}
          error={fieldErrors.educationLevel}
          disabled={isEducationLevelDisabled}
          required
        />
      </div>
    </>
  )
}
